import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MailItem } from '../../../external/MailHistoryApi';
import { actions } from '../../modules/Actions';

export interface MailTopState {
  hit: number;
  // currentPage: number;
  mailHistory: MailItem[];
}

export const initialState: MailTopState = {
  hit: 0,
  // currentPage: 0,
  mailHistory: []
};

export const MailTopReducer = reducerWithInitialState(initialState)
.case(actions.fetchMailTop,(state: MailTopState, payload: MailTopState) => {
    return payload;
  }
);
